export class Router {
  #routes = new Map();
  #current = null;

  constructor(outlet) {
    this.outlet = outlet;
    window.addEventListener("hashchange", () => this.resolve());
  }

  register(path, factory) {
    this.#routes.set(path, factory);
    return this;
  }

  go(path) {
    if (location.hash !== `#${path}`) location.hash = path;
    else this.resolve();
  }

  resolve() {
    const path = location.hash.replace(/^#/, "") || "/";
    const factory = this.#routes.get(path) || this.#routes.get("/");
    this.#current?.destroy?.();
    this.outlet.replaceChildren();
    this.#current = factory();
    this.outlet.append(this.#current.element);
    this.#current.mount?.();
    document.querySelectorAll("[data-nav]").forEach((link) => {
      link.classList.toggle("active", link.getAttribute("href") === `#${path}`);
    });
  }
}
